import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CueResponse, OrderActionRequest, OrderDescriptor } from '@cue/api';
import { ConfigService } from './config.service';
import { AssistDetailRequest, AssistOrderGridItem, AssistOrdersGridRequest } from '../models';
import { ResourceDetail } from '@cue/data';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  private httpClient = inject(HttpClient);
  private configService = inject(ConfigService);

  getAllowedServiceIdsForResourceGuid(resourceGuid: string): Observable<number[]> {
    const url = this.configService.value.apiURL + '/api/assist/resources/' + resourceGuid + '/services/ids';
    return this.httpClient.get<number[]>(url);
  }

  getOrders(request: AssistOrdersGridRequest): Observable<AssistOrderGridItem[]> {
    const url = this.configService.value.apiURL + '/api/orders/list';
    return this.httpClient.post<AssistOrderGridItem[]>(url, request);
  }

  createEventLessOrder(request: OrderActionRequest): Observable<CueResponse> {
    const url = this.configService.value.apiURL + '/api/order/action';
    return this.httpClient.post<CueResponse>(url, request);
  }

  getEventOrders(request: AssistDetailRequest): Observable<OrderDescriptor[]> {
    const url = this.configService.value.apiURL + '/api/orders/detail';
    return this.httpClient.post<OrderDescriptor[]>(url, request);
  }
}
